export default __webpack_public_path__ + "static/media/subheader.c8bc3706.png";